import numeral from 'numeral';
import locales from './locales';

export const SI = 'SI';
export const NO = 'NO';
export const POSITIVE_VARIATIONS = [SI, 'SIM', 'YES'];
export const NEGATIVE_VARIATIONS = [NO, 'NÃO'];
export const NEGATIVE_RESPONSE = 'negativeResponse';
export const AFFIRMATIVE_RESPONSE = 'affirmativeResponse';
export const NEGATIVE_QUESTIONS = 'negativeQuestions';
export const ALL_QUESTIONS = 'allQuestions';
export const NEGATIVE = 'negative';
export const POSITIVE = 'positive';
export const ERROR = 'error';
export const FIRST_QUESTION = 'firstQuestion';

export const STATE = {
  CREATED: 'CREATED',
  OPENED: 'OPENED',
  COMPLETED: 'COMPLETED'
};

export const ORIGIN = {
  MAIL: 'Mail',
  PANEL: 'Panel',
  MODAL_NOTIFICATIONS: 'Modal de notificaciones'
};

export const originsTypes = {
  mail: ORIGIN.MAIL,
  notificacion: ORIGIN.MODAL_NOTIFICATIONS
};

export const getLocale = () => {
  const siteName = process.env.REACT_APP_BUILD_SITE !== undefined ? process.env.REACT_APP_BUILD_SITE : 'ZPAR';
  return locales.get(siteName);
};

export const currencyNumber = (currency, value) => {
  if (currency === 'USD') {
    return `USD ${numeral(value).format()}`;
  }
  return `${getLocale().currency.symbol} ${numeral(value).format()}`;
};

export const includeYesOrNo = value => {
  return [...POSITIVE_VARIATIONS, ...NEGATIVE_VARIATIONS].includes(value.toUpperCase());
};

export const includeYes = value => {
  return POSITIVE_VARIATIONS.includes(value.toUpperCase());
};

export const includeNo = value => {
  return NEGATIVE_VARIATIONS.includes(value?.toUpperCase());
};
